function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { ParentBlot } from 'parchment';
import Module from '../core/module.js';
import Quill from '../core/quill.js';
var isMac = /Mac/i.test(navigator.platform); // Export for testing

export var TTL_FOR_VALID_SELECTION_CHANGE = 100; // A loose check to determine if the shortcut can move the caret before a UI node:
// <ANY_PARENT>[CARET]<div class="ql-ui"></div>[CONTENT]</ANY_PARENT>

var canMoveCaretBeforeUINode = function canMoveCaretBeforeUINode(event) {
  if (event.key === 'ArrowLeft' || event.key === 'ArrowRight' || // RTL scripts or moving from the end of the previous line
  event.key === 'ArrowUp' || event.key === 'ArrowDown' || event.key === 'Home') {
    return true;
  }

  if (isMac && event.key === 'a' && event.ctrlKey === true) {
    return true;
  }

  return false;
};

var UINode = /*#__PURE__*/function (_Module) {
  _inherits(UINode, _Module);

  var _super = _createSuper(UINode);

  function UINode(quill, options) {
    var _this;

    _classCallCheck(this, UINode);

    _this = _super.call(this, quill, options);

    _defineProperty(_assertThisInitialized(_this), "isListening", false);

    _defineProperty(_assertThisInitialized(_this), "selectionChangeDeadline", 0);

    _this.handleArrowKeys();

    _this.handleNavigationShortcuts();

    return _this;
  }

  _createClass(UINode, [{
    key: "handleArrowKeys",
    value: function handleArrowKeys() {
      this.quill.keyboard.addBinding({
        key: ['ArrowLeft', 'ArrowRight'],
        offset: 0,
        shiftKey: null,
        handler: function handler(range, _ref) {
          var line = _ref.line,
              event = _ref.event;

          if (!(line instanceof ParentBlot) || !line.uiNode) {
            return true;
          }

          var isRTL = getComputedStyle(line.domNode)['direction'] === 'rtl';

          if (isRTL && event.key !== 'ArrowRight' || !isRTL && event.key !== 'ArrowLeft') {
            return true;
          }

          this.quill.setSelection(range.index - 1, range.length + (event.shiftKey ? 1 : 0), Quill.sources.USER);
          return false;
        }
      });
    }
  }, {
    key: "handleNavigationShortcuts",
    value: function handleNavigationShortcuts() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (event) {
        if (!event.defaultPrevented && canMoveCaretBeforeUINode(event)) {
          _this2.ensureListeningToSelectionChange();
        }
      });
    }
    /**
     * We only listen to the `selectionchange` event when
     * there is an intention of moving the caret to the beginning using shortcuts.
     * This is primarily implemented to prevent infinite loops, as we are changing
     * the selection within the handler of a `selectionchange` event.
     */

  }, {
    key: "ensureListeningToSelectionChange",
    value: function ensureListeningToSelectionChange() {
      var _this3 = this;

      this.selectionChangeDeadline = Date.now() + TTL_FOR_VALID_SELECTION_CHANGE;
      if (this.isListening) return;
      this.isListening = true;

      var listener = function listener() {
        _this3.isListening = false;

        if (Date.now() <= _this3.selectionChangeDeadline) {
          _this3.handleSelectionChange();
        }
      };

      document.addEventListener('selectionchange', listener, {
        once: true
      });
    }
  }, {
    key: "handleSelectionChange",
    value: function handleSelectionChange() {
      var selection = document.getSelection();
      if (!selection) return;
      var range = selection.getRangeAt(0);
      if (range.collapsed !== true || range.startOffset !== 0) return;
      var line = this.quill.scroll.find(range.startContainer);
      if (!(line instanceof ParentBlot) || !line.uiNode) return;
      var newRange = document.createRange();
      newRange.setStartAfter(line.uiNode);
      newRange.setEndAfter(line.uiNode);
      selection.removeAllRanges();
      selection.addRange(newRange);
    }
  }]);

  return UINode;
}(Module);

export default UINode;